"use strict";
/**
 * Swiss Ephemeris Type Definitions - Enums
 *
 * This file contains all enum definitions for the Swiss Ephemeris library.
 * Enums replace the old numeric constants with type-safe, developer-friendly values.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberOfPlanets = exports.PlanetaryMoonOffset = exports.AsteroidOffset = exports.RiseTransitFlag = exports.SiderealMode = exports.CommonEclipseTypes = exports.EclipseType = exports.CommonCalculationFlags = exports.CalculationFlag = exports.HousePoint = exports.HouseSystem = exports.FictitiousPlanet = exports.Asteroid = exports.LunarPoint = exports.Planet = exports.CalendarType = void 0;
/**
 * Calendar system type
 */
var CalendarType;
(function (CalendarType) {
    /** Julian calendar */
    CalendarType[CalendarType["Julian"] = 0] = "Julian";
    /** Gregorian calendar (default for modern dates) */
    CalendarType[CalendarType["Gregorian"] = 1] = "Gregorian";
})(CalendarType || (exports.CalendarType = CalendarType = {}));
/**
 * Major planets and luminaries
 */
var Planet;
(function (Planet) {
    /** Sun */
    Planet[Planet["Sun"] = 0] = "Sun";
    /** Moon */
    Planet[Planet["Moon"] = 1] = "Moon";
    /** Mercury */
    Planet[Planet["Mercury"] = 2] = "Mercury";
    /** Venus */
    Planet[Planet["Venus"] = 3] = "Venus";
    /** Mars */
    Planet[Planet["Mars"] = 4] = "Mars";
    /** Jupiter */
    Planet[Planet["Jupiter"] = 5] = "Jupiter";
    /** Saturn */
    Planet[Planet["Saturn"] = 6] = "Saturn";
    /** Uranus */
    Planet[Planet["Uranus"] = 7] = "Uranus";
    /** Neptune */
    Planet[Planet["Neptune"] = 8] = "Neptune";
    /** Pluto */
    Planet[Planet["Pluto"] = 9] = "Pluto";
    /** Earth (for heliocentric calculations) */
    Planet[Planet["Earth"] = 14] = "Earth";
    /** Ecliptic and nutation */
    Planet[Planet["EclipticNutation"] = -1] = "EclipticNutation";
    /** Fixed star (special value) */
    Planet[Planet["FixedStar"] = -10] = "FixedStar";
})(Planet || (exports.Planet = Planet = {}));
/**
 * Lunar and solar nodes and apogees
 */
var LunarPoint;
(function (LunarPoint) {
    /** Mean lunar node (North Node) */
    LunarPoint[LunarPoint["MeanNode"] = 10] = "MeanNode";
    /** True lunar node (osculating) */
    LunarPoint[LunarPoint["TrueNode"] = 11] = "TrueNode";
    /** Mean lunar apogee (Lilith) */
    LunarPoint[LunarPoint["MeanApogee"] = 12] = "MeanApogee";
    /** Osculating lunar apogee */
    LunarPoint[LunarPoint["OsculatingApogee"] = 13] = "OsculatingApogee";
    /** Interpolated lunar apogee */
    LunarPoint[LunarPoint["InterpolatedApogee"] = 21] = "InterpolatedApogee";
    /** Interpolated lunar perigee */
    LunarPoint[LunarPoint["InterpolatedPerigee"] = 22] = "InterpolatedPerigee";
})(LunarPoint || (exports.LunarPoint = LunarPoint = {}));
/**
 * Main belt asteroids
 */
var Asteroid;
(function (Asteroid) {
    /** Chiron */
    Asteroid[Asteroid["Chiron"] = 15] = "Chiron";
    /** Pholus */
    Asteroid[Asteroid["Pholus"] = 16] = "Pholus";
    /** Ceres */
    Asteroid[Asteroid["Ceres"] = 17] = "Ceres";
    /** Pallas */
    Asteroid[Asteroid["Pallas"] = 18] = "Pallas";
    /** Juno */
    Asteroid[Asteroid["Juno"] = 19] = "Juno";
    /** Vesta */
    Asteroid[Asteroid["Vesta"] = 20] = "Vesta";
})(Asteroid || (exports.Asteroid = Asteroid = {}));
/**
 * Fictitious planets used in Uranian astrology and other systems
 */
var FictitiousPlanet;
(function (FictitiousPlanet) {
    /** Cupido (Uranian) */
    FictitiousPlanet[FictitiousPlanet["Cupido"] = 40] = "Cupido";
    /** Hades (Uranian) */
    FictitiousPlanet[FictitiousPlanet["Hades"] = 41] = "Hades";
    /** Zeus (Uranian) */
    FictitiousPlanet[FictitiousPlanet["Zeus"] = 42] = "Zeus";
    /** Kronos (Uranian) */
    FictitiousPlanet[FictitiousPlanet["Kronos"] = 43] = "Kronos";
    /** Apollon (Uranian) */
    FictitiousPlanet[FictitiousPlanet["Apollon"] = 44] = "Apollon";
    /** Admetos (Uranian) */
    FictitiousPlanet[FictitiousPlanet["Admetos"] = 45] = "Admetos";
    /** Vulkanus (Uranian) */
    FictitiousPlanet[FictitiousPlanet["Vulkanus"] = 46] = "Vulkanus";
    /** Poseidon (Uranian) */
    FictitiousPlanet[FictitiousPlanet["Poseidon"] = 47] = "Poseidon";
    /** Isis (Transatlantic) */
    FictitiousPlanet[FictitiousPlanet["Isis"] = 48] = "Isis";
    /** Nibiru (hypothetical) */
    FictitiousPlanet[FictitiousPlanet["Nibiru"] = 49] = "Nibiru";
    /** Harrington (hypothetical) */
    FictitiousPlanet[FictitiousPlanet["Harrington"] = 50] = "Harrington";
    /** Neptune according to Leverrier */
    FictitiousPlanet[FictitiousPlanet["NeptuneLeverrier"] = 51] = "NeptuneLeverrier";
    /** Neptune according to Adams */
    FictitiousPlanet[FictitiousPlanet["NeptuneAdams"] = 52] = "NeptuneAdams";
    /** Pluto according to Lowell */
    FictitiousPlanet[FictitiousPlanet["PlutoLowell"] = 53] = "PlutoLowell";
    /** Pluto according to Pickering */
    FictitiousPlanet[FictitiousPlanet["PlutoPickering"] = 54] = "PlutoPickering";
    /** Vulcan (hypothetical planet inside Mercury's orbit) */
    FictitiousPlanet[FictitiousPlanet["Vulcan"] = 55] = "Vulcan";
    /** White Moon (Selena) */
    FictitiousPlanet[FictitiousPlanet["WhiteMoon"] = 56] = "WhiteMoon";
    /** Proserpina */
    FictitiousPlanet[FictitiousPlanet["Proserpina"] = 57] = "Proserpina";
    /** Waldemath (hypothetical second moon) */
    FictitiousPlanet[FictitiousPlanet["Waldemath"] = 58] = "Waldemath";
})(FictitiousPlanet || (exports.FictitiousPlanet = FictitiousPlanet = {}));
/**
 * House systems
 */
var HouseSystem;
(function (HouseSystem) {
    /** Placidus (most common in modern Western astrology) */
    HouseSystem["Placidus"] = "P";
    /** Koch */
    HouseSystem["Koch"] = "K";
    /** Porphyrius */
    HouseSystem["Porphyrius"] = "O";
    /** Regiomontanus */
    HouseSystem["Regiomontanus"] = "R";
    /** Campanus */
    HouseSystem["Campanus"] = "C";
    /** Equal (Ascendant) */
    HouseSystem["Equal"] = "A";
    /** Vehlow Equal */
    HouseSystem["VehlowEqual"] = "V";
    /** Whole Sign */
    HouseSystem["WholeSign"] = "W";
    /** Meridian (Axial rotation) */
    HouseSystem["Meridian"] = "X";
    /** Azimuthal / Horizontal */
    HouseSystem["Azimuthal"] = "H";
    /** Polich/Page ("topocentric") */
    HouseSystem["PolichPage"] = "T";
    /** Alcabitus */
    HouseSystem["Alcabitus"] = "B";
    /** Morinus */
    HouseSystem["Morinus"] = "M";
})(HouseSystem || (exports.HouseSystem = HouseSystem = {}));
/**
 * House cusps and significant points
 * These are indices into the ascmc array returned by houses calculation
 */
var HousePoint;
(function (HousePoint) {
    /** Ascendant */
    HousePoint[HousePoint["Ascendant"] = 0] = "Ascendant";
    /** MC (Medium Coeli / Midheaven) */
    HousePoint[HousePoint["MC"] = 1] = "MC";
    /** ARMC (sidereal time) */
    HousePoint[HousePoint["ARMC"] = 2] = "ARMC";
    /** Vertex */
    HousePoint[HousePoint["Vertex"] = 3] = "Vertex";
    /** Equatorial Ascendant */
    HousePoint[HousePoint["EquatorialAscendant"] = 4] = "EquatorialAscendant";
    /** Co-Ascendant 1 (Koch) */
    HousePoint[HousePoint["CoAscendant1"] = 5] = "CoAscendant1";
    /** Co-Ascendant 2 (Munkasey) */
    HousePoint[HousePoint["CoAscendant2"] = 6] = "CoAscendant2";
    /** Polar Ascendant */
    HousePoint[HousePoint["PolarAscendant"] = 7] = "PolarAscendant";
})(HousePoint || (exports.HousePoint = HousePoint = {}));
/**
 * Calculation flags (bitwise)
 * These can be combined using bitwise OR (|) operator
 */
var CalculationFlag;
(function (CalculationFlag) {
    /** Use JPL ephemeris files */
    CalculationFlag[CalculationFlag["JPLEphemeris"] = 1] = "JPLEphemeris";
    /** Use Swiss Ephemeris files */
    CalculationFlag[CalculationFlag["SwissEphemeris"] = 2] = "SwissEphemeris";
    /** Use Moshier ephemeris (analytical, no files needed) */
    CalculationFlag[CalculationFlag["MoshierEphemeris"] = 4] = "MoshierEphemeris";
    /** Heliocentric positions */
    CalculationFlag[CalculationFlag["Heliocentric"] = 8] = "Heliocentric";
    /** True/geometric positions (no light-time correction) */
    CalculationFlag[CalculationFlag["TruePositions"] = 16] = "TruePositions";
    /** J2000 coordinates */
    CalculationFlag[CalculationFlag["J2000"] = 32] = "J2000";
    /** No nutation */
    CalculationFlag[CalculationFlag["NoNutation"] = 64] = "NoNutation";
    /** High-precision speed (uses 3 positions) */
    CalculationFlag[CalculationFlag["Speed3"] = 128] = "Speed3";
    /** Calculate speed */
    CalculationFlag[CalculationFlag["Speed"] = 256] = "Speed";
    /** No gravitational deflection */
    CalculationFlag[CalculationFlag["NoGravitationalDeflection"] = 512] = "NoGravitationalDeflection";
    /** No aberration */
    CalculationFlag[CalculationFlag["NoAberration"] = 1024] = "NoAberration";
    /** Equatorial coordinates (RA/Dec instead of longitude/latitude) */
    CalculationFlag[CalculationFlag["Equatorial"] = 2048] = "Equatorial";
    /** Rectangular coordinates (X/Y/Z) */
    CalculationFlag[CalculationFlag["XYZ"] = 4096] = "XYZ";
    /** Radians instead of degrees */
    CalculationFlag[CalculationFlag["Radians"] = 8192] = "Radians";
    /** Barycentric positions */
    CalculationFlag[CalculationFlag["Barycentric"] = 16384] = "Barycentric";
    /** Topocentric positions */
    CalculationFlag[CalculationFlag["Topocentric"] = 32768] = "Topocentric";
    /** Sidereal positions */
    CalculationFlag[CalculationFlag["Sidereal"] = 65536] = "Sidereal";
    /** ICRS reference frame */
    CalculationFlag[CalculationFlag["ICRS"] = 131072] = "ICRS";
    /** Nutation according to IAU 1980 */
    CalculationFlag[CalculationFlag["DpsidepsIAU1980"] = 262144] = "DpsidepsIAU1980";
    /** JPL Horizons mode */
    CalculationFlag[CalculationFlag["JPLHorizons"] = 524288] = "JPLHorizons";
    /** JPL Horizons approximation mode */
    CalculationFlag[CalculationFlag["JPLHorizonsApprox"] = 1048576] = "JPLHorizonsApprox";
})(CalculationFlag || (exports.CalculationFlag = CalculationFlag = {}));
/**
 * Common flag combinations for convenience
 */
exports.CommonCalculationFlags = {
    /** Astrometric positions (no aberration or gravitational deflection) */
    Astrometric: CalculationFlag.NoAberration | CalculationFlag.NoGravitationalDeflection,
    /** Default flags for Swiss Ephemeris with speed */
    DefaultSwissEphemeris: CalculationFlag.SwissEphemeris | CalculationFlag.Speed,
    /** Default flags for Moshier with speed */
    DefaultMoshier: CalculationFlag.MoshierEphemeris | CalculationFlag.Speed
};
/**
 * Eclipse type flags (bitwise)
 * These can be combined using bitwise OR (|) operator
 */
var EclipseType;
(function (EclipseType) {
    /** Central eclipse (path of totality/annularity crosses Earth) */
    EclipseType[EclipseType["Central"] = 1] = "Central";
    /** Non-central eclipse */
    EclipseType[EclipseType["NonCentral"] = 2] = "NonCentral";
    /** Total eclipse */
    EclipseType[EclipseType["Total"] = 4] = "Total";
    /** Annular eclipse */
    EclipseType[EclipseType["Annular"] = 8] = "Annular";
    /** Partial eclipse */
    EclipseType[EclipseType["Partial"] = 16] = "Partial";
    /** Annular-total (hybrid) eclipse */
    EclipseType[EclipseType["AnnularTotal"] = 32] = "AnnularTotal";
    /** Penumbral lunar eclipse */
    EclipseType[EclipseType["Penumbral"] = 64] = "Penumbral";
})(EclipseType || (exports.EclipseType = EclipseType = {}));
/**
 * Common eclipse type combinations
 */
exports.CommonEclipseTypes = {
    /** All types of solar eclipses */
    AllSolar: EclipseType.Central | EclipseType.NonCentral | EclipseType.Total |
        EclipseType.Annular | EclipseType.Partial | EclipseType.AnnularTotal,
    /** All types of lunar eclipses */
    AllLunar: EclipseType.Total | EclipseType.Partial | EclipseType.Penumbral
};
/**
 * Sidereal modes (Ayanamsa systems)
 * Used with setSiderealMode() for sidereal astrology calculations
 */
var SiderealMode;
(function (SiderealMode) {
    /** Fagan/Bradley (default) */
    SiderealMode[SiderealMode["FaganBradley"] = 0] = "FaganBradley";
    /** Lahiri (most common in Vedic astrology) */
    SiderealMode[SiderealMode["Lahiri"] = 1] = "Lahiri";
    /** De Luce */
    SiderealMode[SiderealMode["DeLuce"] = 2] = "DeLuce";
    /** Raman */
    SiderealMode[SiderealMode["Raman"] = 3] = "Raman";
    /** Ushashashi */
    SiderealMode[SiderealMode["Ushashashi"] = 4] = "Ushashashi";
    /** Krishnamurti */
    SiderealMode[SiderealMode["Krishnamurti"] = 5] = "Krishnamurti";
    /** Djwhal Khul */
    SiderealMode[SiderealMode["DjwhalKhul"] = 6] = "DjwhalKhul";
    /** Yukteshwar */
    SiderealMode[SiderealMode["Yukteshwar"] = 7] = "Yukteshwar";
    /** JN Bhasin */
    SiderealMode[SiderealMode["JNBhasin"] = 8] = "JNBhasin";
    /** Babylonian (Kugler 1) */
    SiderealMode[SiderealMode["BabylKugler1"] = 9] = "BabylKugler1";
    /** Babylonian (Kugler 2) */
    SiderealMode[SiderealMode["BabylKugler2"] = 10] = "BabylKugler2";
    /** Babylonian (Kugler 3) */
    SiderealMode[SiderealMode["BabylKugler3"] = 11] = "BabylKugler3";
    /** Babylonian (Huber) */
    SiderealMode[SiderealMode["BabylHuber"] = 12] = "BabylHuber";
    /** Babylonian (EtPSC) */
    SiderealMode[SiderealMode["BabylEtPSC"] = 13] = "BabylEtPSC";
    /** Aldebaran at 15 Taurus */
    SiderealMode[SiderealMode["Aldebaran15Tau"] = 14] = "Aldebaran15Tau";
    /** Hipparchos */
    SiderealMode[SiderealMode["Hipparchos"] = 15] = "Hipparchos";
    /** Sassanian */
    SiderealMode[SiderealMode["Sassanian"] = 16] = "Sassanian";
    /** Galactic Center at 0 Sagittarius */
    SiderealMode[SiderealMode["GalacticCenter0Sag"] = 17] = "GalacticCenter0Sag";
    /** J2000 */
    SiderealMode[SiderealMode["J2000"] = 18] = "J2000";
    /** J1900 */
    SiderealMode[SiderealMode["J1900"] = 19] = "J1900";
    /** B1950 */
    SiderealMode[SiderealMode["B1950"] = 20] = "B1950";
    /** Surya Siddhanta */
    SiderealMode[SiderealMode["SuryaSiddhanta"] = 21] = "SuryaSiddhanta";
    /** Surya Siddhanta (Mean Sun) */
    SiderealMode[SiderealMode["SuryaSiddhantaMeanSun"] = 22] = "SuryaSiddhantaMeanSun";
    /** Aryabhata */
    SiderealMode[SiderealMode["Aryabhata"] = 23] = "Aryabhata";
    /** Aryabhata (Mean Sun) */
    SiderealMode[SiderealMode["AryabhataMeanSun"] = 24] = "AryabhataMeanSun";
    /** SS Revati */
    SiderealMode[SiderealMode["SSRevati"] = 25] = "SSRevati";
    /** SS Citra */
    SiderealMode[SiderealMode["SSCitra"] = 26] = "SSCitra";
    /** True Citra */
    SiderealMode[SiderealMode["TrueCitra"] = 27] = "TrueCitra";
    /** True Revati */
    SiderealMode[SiderealMode["TrueRevati"] = 28] = "TrueRevati";
    /** True Pushya */
    SiderealMode[SiderealMode["TruePushya"] = 29] = "TruePushya";
    /** Galactic Center (Gil Brand) */
    SiderealMode[SiderealMode["GalacticCenterGilBrand"] = 30] = "GalacticCenterGilBrand";
    /** Galactic Equator (IAU 1958) */
    SiderealMode[SiderealMode["GalacticEquatorIAU1958"] = 31] = "GalacticEquatorIAU1958";
    /** Galactic Equator */
    SiderealMode[SiderealMode["GalacticEquator"] = 32] = "GalacticEquator";
    /** Galactic Equator (Mid Mula) */
    SiderealMode[SiderealMode["GalacticEquatorMidMula"] = 33] = "GalacticEquatorMidMula";
    /** Skydram (Mardyks) */
    SiderealMode[SiderealMode["Skydram"] = 34] = "Skydram";
    /** True Mula (Chandra Hari) */
    SiderealMode[SiderealMode["TrueMula"] = 35] = "TrueMula";
    /** Dhruva/Galactic Center/Mula (Wilhelm) */
    SiderealMode[SiderealMode["DhruvaGalCenterMulaWilhelm"] = 36] = "DhruvaGalCenterMulaWilhelm";
    /** Aryabhata 522 */
    SiderealMode[SiderealMode["Aryabhata522"] = 37] = "Aryabhata522";
    /** Babylonian/Britton */
    SiderealMode[SiderealMode["BabylBritton"] = 38] = "BabylBritton";
    /** User defined ayanamsa */
    SiderealMode[SiderealMode["UserDefined"] = 255] = "UserDefined";
})(SiderealMode || (exports.SiderealMode = SiderealMode = {}));
/**
 * Rise/transit/set event type
 */
var RiseTransitFlag;
(function (RiseTransitFlag) {
    /** Rising event */
    RiseTransitFlag[RiseTransitFlag["Rise"] = 1] = "Rise";
    /** Setting event */
    RiseTransitFlag[RiseTransitFlag["Set"] = 2] = "Set";
    /** Upper transit (culmination) */
    RiseTransitFlag[RiseTransitFlag["UpperTransit"] = 4] = "UpperTransit";
    /** Lower transit (anti-culmination) */
    RiseTransitFlag[RiseTransitFlag["LowerTransit"] = 8] = "LowerTransit";
})(RiseTransitFlag || (exports.RiseTransitFlag = RiseTransitFlag = {}));
/**
 * Constants for special offsets
 */
exports.AsteroidOffset = 10000;
exports.PlanetaryMoonOffset = 9000;
exports.NumberOfPlanets = 23;
